module.exports = __webpack_public_path__ + "assets/img/kv-62fec306.jpg";